import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { XIcon, SendIcon } from 'lucide-react';
type AstroBotProps = {
  onClose: () => void;
};
export const AstroBot: React.FC<AstroBotProps> = ({
  onClose
}) => {
  const [messages, setMessages] = useState([{
    sender: 'bot',
    text: "Hi there! I'm AstroBot, your cosmic career guide. How can I help you today?"
  }]);
  const [input, setInput] = useState('');
  const handleSend = () => {
    if (!input.trim()) return;
    // Add user message
    setMessages([...messages, {
      sender: 'user',
      text: input
    }]);
    // Simulate bot response (in a real app, this would call an API)
    setTimeout(() => {
      const botResponses = ["Based on your cosmic profile, I'd recommend exploring creative fields that allow you to express your unique perspective.", 'Your chart shows strong analytical abilities! Have you considered roles that involve problem-solving?', "I notice you're interested in that field! Your Mercury placement suggests you'd excel in communication-heavy roles.", 'According to your assessment results, you might enjoy collaborative environments that value innovation.'];
      const randomResponse = botResponses[Math.floor(Math.random() * botResponses.length)];
      setMessages(prev => [...prev, {
        sender: 'bot',
        text: randomResponse
      }]);
    }, 1000);
    setInput('');
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: 20
  }} className="fixed bottom-6 right-6 w-80 md:w-96 h-96 bg-[#0A1128] rounded-lg shadow-xl overflow-hidden z-50 flex flex-col" data-id="element-621">
      <div className="bg-gradient-to-r from-[#7D56F4] to-[#19D3DA] py-3 px-4 flex justify-between items-center" data-id="element-622">
        <div className="flex items-center" data-id="element-623">
          <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center text-xl mr-2" data-id="element-624">
            ✨
          </div>
          <h3 className="font-medium text-white" data-id="element-625">AstroBot</h3>
        </div>
        <button onClick={onClose} className="text-white hover:bg-white/10 rounded-full p-1" data-id="element-626">
          <XIcon size={18} data-id="element-627" />
        </button>
      </div>
      <div className="flex-1 overflow-y-auto p-4 space-y-4" data-id="element-628">
        {messages.map((message, index) => <div key={index} className={`flex ${message.sender === 'user' ? 'justify-end' : 'justify-start'}`} data-id="element-629">
            <div className={`max-w-[80%] rounded-lg px-3 py-2 ${message.sender === 'user' ? 'bg-[#7D56F4] text-white' : 'bg-[#1C2541] text-white'}`} data-id="element-630">
              {message.text}
            </div>
          </div>)}
      </div>
      <div className="border-t border-[#1C2541] p-3" data-id="element-631">
        <div className="flex items-center bg-[#1C2541] rounded-full overflow-hidden" data-id="element-632">
          <input type="text" value={input} onChange={e => setInput(e.target.value)} onKeyPress={e => e.key === 'Enter' && handleSend()} placeholder="Ask AstroBot a question..." className="flex-1 bg-transparent border-none outline-none px-4 py-2 text-white" data-id="element-633" />
          <button onClick={handleSend} className="bg-[#7D56F4] text-white p-2 rounded-full mr-1" data-id="element-634">
            <SendIcon size={16} data-id="element-635" />
          </button>
        </div>
      </div>
    </motion.div>;
};